export const CONFIG = {
  VIDEO_URL_DESKTOP: 'https://storage.googleapis.com/argo-app-prod/static/outlaw_web.mp4',
  supportEmail: 'info@ot4.life',
  inquiriesEmail: 'inquiries@maji.la',
  companyName: 'Outlaw Tech',
  TITLE: 'MAJI.LA',
  domen: 'https://maji.la',
}
